module.exports = __webpack_public_path__ + "static/ai-stylist-opener.b7d16892.png";